import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';
import { sum } from 'radash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckoutModel } from 'src/core/model/quarter-overview.model';

export type Props = {
  readonly list?: CheckoutModel[];
};

export function CheckoutTable(props: Props): React.JSX.Element {
  const { list = [] } = props;
  const { t } = useTranslation();

  const totalHT = useMemo(() => sum(list, (item) => item.totalHT ?? 0), [list]);

  const checkoutTranslations: Record<keyof CheckoutModel, string> = t(
    'model.checkout-fee',
    {
      returnObjects: true,
    },
  );

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{checkoutTranslations.iTransactionId}</TableCell>
          <TableCell>{checkoutTranslations.breakdownType}</TableCell>
          <TableCell align="right">{checkoutTranslations.totalHT}</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {list.map((checkoutFee) => (
          <TableRow key={checkoutFee.iTransactionId}>
            <TableCell>{checkoutFee.iTransactionId}</TableCell>
            <TableCell>{checkoutFee.breakdownType}</TableCell>

            <TableCell align="right">
              {t('data-grid.row.currency', {
                value: checkoutFee.totalHT,
              })}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>

      <TableFooter>
        <TableRow>
          <TableCell colSpan={2}>
            {t('quarter-overview.checkout-section.total')}
          </TableCell>
          <TableCell align="right">
            {t('data-grid.row.currency', {
              value: totalHT,
            })}
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  );
}
